import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';
import * as style from './ModalNewResearch.module.less';
import { observable } from 'mobx';
import { useEffect, useState } from 'react';
import right_art from './modal.png';
import { Split } from '../Split/Split';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { ReportStep, useStore, useStoreUI } from '@assets/model/Store';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import Checkbox from '../UI/Checkbox/Checkbox';
import { useNavUtils } from '@assets/utils/NavUtils';

class FlowiseRerunStore {
    constructor() {}

    @observable accessor selected_steps: { [index: number]: boolean } = {};
    @observable accessor runPostProcessing: boolean = true;
    @observable accessor createNewReport: boolean = true;
}

export const ModalFlowiseRerunStep = observer(() => {
    const [localStore] = useState(new FlowiseRerunStore());
    const report = useStore().reportDefinitions['insight_report_no_cim'];

    useEffect(() => {
        loadStepsSelection();
    }, []);

    const renderStep = (index: number, step: ReportStep) => {
        const hasFlowId = step.flow_id && step.flow_id.length > 0;
        const flowLink =
            'https://flowise-test.flightlinedata.com/v2/agentcanvas/' +
            step.flow_id;
        const bgColor = index % 2 == 0 ? '#b6b6cfff' : '#deddddff';
        const isSelected = localStore.selected_steps[index] === true;
        return (
            <Flex
                direction="row"
                wrap={'wrap'}
                fillCell={true}
                key={'step-' + index}
                style={{
                    backgroundColor: bgColor,
                    gap: '10px',
                    rowGap: '0px',
                    marginBottom: '10px'
                }}
            >
                <Checkbox
                    checked={isSelected}
                    onChange={(value: boolean) => {
                        localStore.selected_steps[index] = value;
                        storeStepsSelection();
                    }}
                ></Checkbox>
                <div>#{index}</div>
                <div style={{ flex: '1' }}>{step.name}</div>
                <div>
                    Type: <b>{step.type}</b>
                </div>
                <div style={{ flex: '1 1 100%' }}></div>
                <div style={{ paddingLeft: '30px' }}>
                    SaveTo: <b>{step.save_to}</b>
                </div>
                {hasFlowId && (
                    <div style={{ paddingLeft: '20px' }}>
                        <a href={flowLink} target="_blank" rel="noreferrer">
                            View Flow
                        </a>
                    </div>
                )}
            </Flex>
        );
    };
    const selectedSteps = Object.keys(localStore.selected_steps).filter(
        key => localStore.selected_steps[key]
    );
    const storeUI = useStoreUI();
    const onRunReport = () => {
        const selectedSteps: number[] = Object.keys(localStore.selected_steps)
            .filter(key => localStore.selected_steps[key])
            .map(s => parseInt(s));

        if (selectedSteps.length == 0) {
            alert('Please select at least one step to rerun');
            return;
        }

        const reportId = useStore().selectedReportId;

        const modeMsg = localStore.createNewReport ? 'Create New Report' : 'Overwrite Existing';
        const postProcMsg = localStore.runPostProcessing ? ' + Post-Processing' : '';
        const msg = `Mode: ${modeMsg}\nReport: ${reportId}\nSteps: ${selectedSteps.join(', ')}${postProcMsg}\n\nProceed?`;
        if (!confirm(msg)) return;

        const fb = getFirebase();
        fb.add_research_job(
            reportId,
            'RERUN',
            'RERUN',
            'RERUN',
            reportId,
            selectedSteps,
            localStore.runPostProcessing,
            localStore.createNewReport
        );
        storeUI.modal = null;
        setTimeout(() => {
            window.location.href = '/';
        }, 750);
    };

    const storeStepsSelection = () => {
        const selected = localStore.selected_steps;
        const s = localStorage.setItem(
            'flowise_rerun_steps',
            JSON.stringify(selected)
        );
    };

    const loadStepsSelection = () => {
        const s = localStorage.getItem('flowise_rerun_steps');
        if (s) {
            try {
                const obj = JSON.parse(s);
                localStore.selected_steps = obj;
            } catch (e) {
                console.error('Failed to load steps selection:', e);
            }
        }
    };
    return (
        <Flex fillCell={true} direction="column">
            <ScrollPanel>
                <Flex fillCell={true} direction="column">
                    {/* Report Creation Mode Selection */}
                    <Flex
                        direction="column"
                        fillCell={true}
                        style={{
                            backgroundColor: '#f8f9fa',
                            padding: '15px',
                            marginBottom: '20px',
                            border: '1px solid #dee2e6',
                            borderRadius: '4px'
                        }}
                    >
                        <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                            Rerun Mode:
                        </div>
                        <Flex direction="row" style={{ gap: '20px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="reportMode"
                                    checked={localStore.createNewReport}
                                    onChange={() => {
                                        localStore.createNewReport = true;
                                    }}
                                    style={{ marginRight: '8px', cursor: 'pointer' }}
                                />
                                <span>Create New Report</span>
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="reportMode"
                                    checked={!localStore.createNewReport}
                                    onChange={() => {
                                        localStore.createNewReport = false;
                                    }}
                                    style={{ marginRight: '8px', cursor: 'pointer' }}
                                />
                                <span>Overwrite Existing Report</span>
                            </label>
                        </Flex>
                        <div style={{ fontSize: '0.85em', color: '#666', marginTop: '8px', paddingLeft: '4px' }}>
                            {localStore.createNewReport
                                ? 'Creates a new report based on this one with a new ID. Original report remains unchanged.'
                                : 'Overwrites the existing report. Original data will be replaced.'}
                        </div>
                    </Flex>

                    <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        Select Steps to Rerun:
                    </div>

                    {report.steps.map((s, index) => renderStep(index, s))}

                    {/* Post-processing option */}
                    <Flex
                        direction="row"
                        wrap={'wrap'}
                        fillCell={true}
                        style={{
                            backgroundColor: '#e8f4f8',
                            gap: '10px',
                            rowGap: '0px',
                            marginTop: '20px',
                            marginBottom: '10px',
                            padding: '10px',
                            border: '2px solid #4a90e2'
                        }}
                    >
                        <Checkbox
                            checked={localStore.runPostProcessing}
                            onChange={(value: boolean) => {
                                localStore.runPostProcessing = value;
                            }}
                        ></Checkbox>
                        <div style={{ flex: '1', fontWeight: 'bold' }}>Run Post-Processing</div>
                        <div style={{ flex: '1 1 100%' }}></div>
                        <div style={{ paddingLeft: '30px', fontSize: '0.85em', color: '#666' }}>
                            Includes: Customer extraction, Transform report into fields, Generate PDF export
                        </div>
                    </Flex>
                </Flex>
            </ScrollPanel>
            <Flex direction="row" style={{ height: '60px', padding: '10px' }}>
                <div>
                    Selected Steps: {selectedSteps.join(', ')}
                    {localStore.runPostProcessing && ' + Post-Processing'}
                </div>
                <div style={{ flex: '1' }}></div>
                <Button onClick={onRunReport}>Run</Button>
            </Flex>
        </Flex>
    );
});
